import { TextField } from '@mui/material';

type EmailInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  required: boolean;
};

export function BirthRegistrationNumberInput({
  value,
  onChange,
  required,
}: EmailInputProps) {
  return (
    <TextField
      label='Geburtenregisternummer'
      size='small'
      value={value}
      onChange={event =>
        onChange(event.target.value === '' ? null : event.target.value)
      }
      fullWidth
      type='text'
      required={required}
    />
  );
}
